import { useWishlist } from '@/components/hooks/useWishlist'
import register from 'preact-custom-element'
import { useEffect } from 'preact/hooks'

const WishlistHeader = ({ children, ...props }) => {
  const { wishlists } = useWishlist(false)

  useEffect(() => {
    if (!GM_STATE?.customer?.logged) return

    // If there are items in the wishlist, set the icon to filled
    const hasItems = wishlists.length > 0 && wishlists.some((wishlist) => wishlist.items.length > 0)
    document.querySelectorAll('.header-heart-icon use').forEach((icon) => {
      icon.setAttribute('href', hasItems ? '#heart-filled' : '#heart')
    })
  }, [wishlists])
}

register(WishlistHeader, 'x-wishlist-header')
